import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'napa-square-close-icon',
  standalone: true,
  templateUrl: './square-close-icon.component.html',
  styleUrl: './square-close-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SquareCloseIconComponent {}
